import { render, staticRenderFns } from "./CourseInfoTab.vue?vue&type=template&id=41046169&scoped=true&"
import script from "./CourseInfoTab.vue?vue&type=script&lang=js&"
export * from "./CourseInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoTab.vue?vue&type=style&index=0&id=41046169&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41046169",
  null
  
)

export default component.exports